import {Nullish} from 'shared/web';

import {VehicleV2ResponseBody} from '../api/types/onlineOfferTypes';

const FUEL_TYPE_ELECTRIC = 'FUELTYPE_ELECTRIC';
const HYBRID_TYPE_FULL = 'HYBRIDTYPE_FULL';
const HYBRID_TYPE_PHEV = 'HYBRIDTYPE_PHEV';
const HYBRID_TYPE_MHEV = 'HYBRIDTYPE_MHEV';
const HYBRID_TYPE_MICRO = 'HYBRIDTYPE_MICRO';

export type VehicleConsumptionVariant = 'A' | 'B' | 'C' | 'D';

export function getVehicleConsumptionVariant(
  vehicle: VehicleV2ResponseBody | Nullish
): VehicleConsumptionVariant {
  if (!vehicle) {
    return 'A';
  }

  const fuelType = vehicle.fuelType;
  const hybridType = vehicle.hybridType;

  if (fuelType === FUEL_TYPE_ELECTRIC) {
    return 'B';
  }

  if (hybridType === HYBRID_TYPE_FULL) {
    return 'C';
  }

  if (hybridType === HYBRID_TYPE_PHEV) {
    return 'D';
  }

  if (hybridType === HYBRID_TYPE_MHEV || hybridType === HYBRID_TYPE_MICRO) {
    return 'A';
  }

  return 'A';
}

export function shouldShowFuelConsumptionInDetails(variant: VehicleConsumptionVariant): boolean {
  return variant === 'A' || variant === 'D';
}

export function shouldShowElectricalConsumptionInDetails(
  variant: VehicleConsumptionVariant
): boolean {
  return variant === 'B' || variant === 'C';
}

export function shouldShowElectricalConsumptionInElectricalParams(
  variant: VehicleConsumptionVariant
): boolean {
  return variant === 'D';
}

export function shouldShowElectricalParameters(variant: VehicleConsumptionVariant): boolean {
  return variant === 'B' || variant === 'C' || variant === 'D';
}

export function shouldShowBatteryOwnershipAndBidirectional(
  variant: VehicleConsumptionVariant
): boolean {
  return variant === 'B' || variant === 'D';
}
